<template>
  <article class="performer-twitter-item">
    <Timeline :id="accountId" sourceType="profile"/>
  </article>
</template>

<script>
import { Timeline } from "vue-tweet-embed"

export default {
  components: {
    Timeline
  },
  props: {
    accountId: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

  .performer-twitter-item {
    overflow: auto;
    border: 1px solid #c8c8c8;
    min-width: 355px;
    width: 100%;
    height: 450px;

    @media screen and (max-width: $breakpoint) {
      min-width: 100%;
    }

  }
</style>
